import { currentConfig } from './config';

// Função para injetar estilos CSS dinâmicos baseados na configuração atual
export const injectDynamicStyles = () => {
  const styleId = 'dynamic-project-styles';
  
  // Remove o estilo anterior se existir
  const existingStyle = document.getElementById(styleId);
  if (existingStyle) {
    existingStyle.remove();
  }

  // Cria novo elemento de estilo
  const style = document.createElement('style');
  style.id = styleId;
  
  // CSS dinâmico baseado na configuração atual
  style.textContent = `
    .fundo {
      background-image: url('${currentConfig.backgroundImage}');
      height: 40%;
      background-position: top;
      background-repeat: no-repeat;
      background-size: cover;
      width: 100%;
    }
  `;

  // Adiciona ao head do documento
  document.head.appendChild(style);
};

// Exporta uma função que pode ser usada em qualquer componente
export const useDynamicStyles = () => {
  return {
    backgroundImage: currentConfig.backgroundImage,
    backgroundImagePath: currentConfig.backgroundImagePath,
    logo: currentConfig.logo,
    projectName: currentConfig.name,
    baseURL: currentConfig.baseURL
  };
};
